import { Theme, useMediaQuery } from '@pogokid/mui'

export function useIsMdBreakpoint() {
  return useMediaQuery(
    (theme: Theme) => theme.breakpoints.up('md'),
    { noSsr: true }
  )
}

export function useIsLgBreakpoint() {
  return useMediaQuery((theme: Theme) =>
    theme.breakpoints.up('lg')
  )
}
